"use strict";

exports.__esModule = true;
exports.range = exports.getIdFromString = exports.getUniqueID = exports.ellipsify = exports.lockWindow = exports.getObjectProperty = exports.getStoredBrand = exports.resizeWindow = exports.getIcon = exports.getLogo = void 0;

var _Logos = require("../components/Logos");

var _Icons = require("../components/Icon/Icons");

var getLogo = function getLogo(brand) {
  var Logo;

  switch (brand) {
    case 'horizon':
      Logo = _Logos.HorizonLogo;
      break;

    case 'cannesLions':
      Logo = _Logos.CannesLionsLogo;
      break;

    case 'eurobest':
      Logo = _Logos.EurobestLogo;
      break;

    case 'lionsLive':
      Logo = _Logos.LionsLiveLogo;
      break;

    case 'money2020':
      Logo = _Logos.Money2020Logo;
      break;

    case 'spikes':
      Logo = _Logos.SpikesLogo;
      break;

    case 'ascential':
      Logo = _Logos.AscentialLogo;
      break;

    case 'dcl':
      Logo = _Logos.DclLogo;
      break;

    case 'lionsCreativity':
      Logo = _Logos.LionsCreativityLogo;
      break;

    default:
      break;
  }

  return Logo;
};

exports.getLogo = getLogo;

var getIcon = function getIcon(iconName) {
  var icon = {};

  switch (iconName) {
    case 'ArrowUp':
      icon.name = _Icons.ArrowUp;
      break;

    case 'Bookmark':
      icon.name = _Icons.Bookmark;
      break;

    case 'ChevronDown':
      icon.name = _Icons.ChevronDown;
      break;

    case 'ChevronUp':
      icon.name = _Icons.ChevronDown;
      icon.props = {
        transform: 'rotate(180deg)'
      };
      break;

    case 'ChevronRight':
      icon.name = _Icons.ChevronDown;
      icon.props = {
        transform: 'rotate(-90deg)'
      };
      break;

    case 'ChevronLeft':
      icon.name = _Icons.ChevronDown;
      icon.props = {
        transform: 'rotate(90deg)'
      };
      break;

    case 'Download':
      icon.name = _Icons.Download;
      break;

    case 'ExternalLink':
      icon.name = _Icons.ExternalLink;
      break;

    case 'FacebookSquare':
      icon.name = _Icons.FacebookSquare;
      break;

    case 'TwitterSquare':
      icon.name = _Icons.TwitterSquare;
      break;

    case 'LinkedinSquare':
      icon.name = _Icons.LinkedinSquare;
      break;

    case 'InstagramSquare':
      icon.name = _Icons.InstagramSquare;
      break;

    case 'YoutubeSquare':
      icon.name = _Icons.YoutubeSquare;
      break;

    case 'Menu':
      icon.name = _Icons.Menu;
      break;

    case 'AlertCircle':
      icon.name = _Icons.AlertCircle;
      break;

    case 'Logout':
      icon.name = _Icons.Logout;
      break;

    case 'Plus':
      icon.name = _Icons.Plus;
      break;

    case 'Minus':
      icon.name = _Icons.Minus;
      break;

    case 'X':
      icon.name = _Icons.X;
      break;

    case 'Check':
      icon.name = _Icons.Check;
      break;

    case 'Disk':
      icon.name = _Icons.Disk;
      break;

    case 'Search':
      icon.name = _Icons.Search;
      break;

    case 'Clock':
      icon.name = _Icons.Clock;
      break;

    case 'Bell':
      icon.name = _Icons.Bell;
      break;

    case 'Mail':
      icon.name = _Icons.Mail;
      break;

    case 'Calendar':
      icon.name = _Icons.Calendar;
      break;

    case 'MapMarker':
      icon.name = _Icons.MapMarker;
      break;

    case 'Play':
      icon.name = _Icons.Play;
      break;

    case 'User':
      icon.name = _Icons.User;
      break;

    case 'UserCircle':
      icon.name = _Icons.UserCircle;
      break;

    case 'SunBurst':
      icon.name = _Icons.SunBurst;
      break;

    default:
      break;
  }

  return icon;
};

exports.getIcon = getIcon;

var resizeWindow = function resizeWindow(x) {
  global.window.innerWidth = x;
  global.window.dispatchEvent(new Event('resize'));
};

exports.resizeWindow = resizeWindow;

var getStoredBrand = function getStoredBrand(allBrands) {
  var DEFAULT_BRAND = 'horizon';
  var slug = localStorage && localStorage.getItem('selected-brand') || DEFAULT_BRAND;
  var brand = null;

  if (slug) {
    brand = allBrands.find(function (i) {
      return i.slug === slug;
    });
  }

  return brand;
};

exports.getStoredBrand = getStoredBrand;

var getObjectProperty = function getObjectProperty(cases, key, defaultCase) {
  // eslint-disable-next-line no-prototype-builtins
  if (cases.hasOwnProperty(key)) {
    return cases[key];
  }

  return cases[defaultCase];
};

exports.getObjectProperty = getObjectProperty;

var lockWindow = function lockWindow(isLocked) {
  if (typeof document !== "undefined") {
    if (isLocked) {
      document.querySelector('html').style.overflow = 'hidden';
    } else {
      document.querySelector('html').style.overflow = '';
    }
  }
};

exports.lockWindow = lockWindow;

var ellipsify = function ellipsify(str, limit) {
  if (str.length > limit) {
    return "".concat(str.substring(0, limit), "...");
  }

  return str;
};

exports.ellipsify = ellipsify;
var lastId = 0;

var getUniqueID = function getUniqueID() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id';
  lastId += 1;
  return "".concat(prefix).concat(lastId);
};

exports.getUniqueID = getUniqueID;

var getIdFromString = function getIdFromString(s) {
  return s.replace(/[^A-Z0-9]/gi, '').toLowerCase();
}; // Create an array given the first and the last value


exports.getIdFromString = getIdFromString;

var range = function range(start, end) {
  var length = end - start + 1;
  return Array.from({
    length: length
  }, function (_, index) {
    return index + start;
  });
};

exports.range = range;